import { render, staticRenderFns } from "./the-feedback-details.vue?vue&type=template&id=31aec675&scoped=true&"
import script from "./the-feedback-details.vue?vue&type=script&lang=js&"
export * from "./the-feedback-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aec675",
  null
  
)

export default component.exports